import React from 'react';
import { useParams } from 'react-router-dom';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { TripMatch, TripRequest } from '@marageti/z4-sdk/lib/travel';
import TripReviewSubmitView from './trip-review-submit-view';

const TripReviewSubmittedContainer = () => {
  const { tripMatchId } = useParams();
  const apiClient = useApiClient();
  const tripMatch = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], !!tripMatchId);
  const tripRequest = useFetch<TripRequest>(apiClient.tripRequestsClient.getTripRequest, [tripMatch.data?.tripRequestId], !!tripMatch.data?.tripRequestId);

  return (
    <TripReviewSubmitView
      photoId={tripRequest.data?.photoId}
      tripRequestId={tripRequest.data?.id}
      isLoading={tripMatch.isLoading || tripRequest.isLoading}
    />
  );
};

export default TripReviewSubmittedContainer;
